import { BASE_API_URL } from '../constants'
import { ax } from '../utils/axios/axios'

interface Options {
  query?: string
}

export const apiSprayBinderTypeDepotSearch = ({ query }: Options = {}) => {
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/ref/spraybindertypedepots`,
    params: query ? { search: query } : undefined
  }
  return ax(options)
}